import { Component } from '@angular/core';

@Component({
	selector: 'cmv-dev-banner',
	templateUrl: './dev-banner.component.html',
	styleUrls: ['./dev-banner.component.scss'],
})
export class DevBannerComponent {
	constructor() {}
}
